"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateDepositFieldsStyles = void 0;
var calculateDepositFieldsStyles = function (fields, currentField, isMobile) {
    var calculatedStyles = {};
    if (currentField === 'firstName' && isMobile) {
        calculatedStyles['marginRight'] = '8px';
    }
    if (currentField === 'zip') {
        var isCityFoundInFields = fields === null || fields === void 0 ? void 0 : fields.find(function (filed) { return filed.type === 'city'; });
        if (isCityFoundInFields)
            calculatedStyles['width'] = isMobile
                ? 'calc(33.33% - 8px)'
                : 'calc(15.33% - 6px)';
        if (isCityFoundInFields && isMobile)
            calculatedStyles['marginRight'] = '8px';
    }
    if (currentField === 'city') {
        var isZipFoundInFields = fields === null || fields === void 0 ? void 0 : fields.find(function (filed) { return filed.type === 'zip'; });
        if (isZipFoundInFields)
            calculatedStyles['width'] = calculatedStyles['width'] = isMobile
                ? 'calc(66.67%)'
                : 'calc(34.67% - 3px)';
    }
    if (currentField === 'addressNumber') {
        var isAddressInFields = fields === null || fields === void 0 ? void 0 : fields.find(function (filed) { return filed.type === 'address'; });
        if (isAddressInFields)
            calculatedStyles['width'] = calculatedStyles['width'] = isMobile
                ? 'calc(33.33% - 8px)'
                : 'calc(15.33% - 6px)';
        if (isAddressInFields && isMobile)
            calculatedStyles['marginRight'] = '8px';
    }
    if (currentField === 'address') {
        var isAddressNumberInFields = fields === null || fields === void 0 ? void 0 : fields.find(function (filed) { return filed.type === 'addressNumber'; });
        if (isAddressNumberInFields)
            calculatedStyles['width'] = calculatedStyles['width'] = isMobile
                ? 'calc(66.67%)'
                : 'calc(34.67% - 3px)';
    }
    return { calculatedStyles: calculatedStyles };
};
exports.calculateDepositFieldsStyles = calculateDepositFieldsStyles;
